import { 
    useContext,
    useEffect, 
    useState 
} from 'react';
import { useRouter } from 'next/router';

import { RequestNextApi } from '../../../../api/Request';
import { MembershipJoinContext } from '../../../../components/Context/membershipJoinContext';
import { ProgressContext } from '../../../../components/Context/progressContext';
import { UserContext } from '../../../../components/Context/userContext';
import RequiredInfo from '../../../../components/MembershipJoin/RequiredInfo';
import MembershipType from '../../../../components/MembershipJoin/MembershipType';
import MarketingNavigation from '../../../../navigation/marketing';
import { getCookie } from '../../../../utils/cookieHandle';
import { ShowNotification } from '../../../../utils/notification/snackbarUtils';

export default function MembershipJoin() {
    const { state: progressContext, update: updateProgress} = useContext(ProgressContext);
    const { state: membershipInfoContext, update: updateMembershipInfo} = useContext(MembershipJoinContext);
    const { state: userContext, update: updateUser } = useContext(UserContext);
    
    const [dateExpires, setDateExpires] = useState();

    const router = useRouter();
    
    useEffect(() => {
        const initPage = async () => {
            updateProgress({isLoading: true});
            const result = await RequestNextApi.post('/user/user-fetch2',
                {
                    jwtToken: getCookie('jwt-token')
                }
            );
            if (result.data.success) {
                updateUser({ user: result.data.user });
                setDateExpires(result.data.user.dateExpires);
                if (!result.data.user.dateExpires) {
                    updateMembershipInfo({
                        ...membershipInfoContext,
                        user: {
                            ...membershipInfoContext.user,
                            userId: result.data.user.id,
                            email: result.data.user.email
                        }
                    });
                } else {
                    ShowNotification.info('Current or past members are not able to use this form')
                }
            } else {
                ShowNotification.error(result.data.message);
            }
            updateProgress({isLoading: false});
        };
        initPage();
    }, []);

    const handleClickSubmit = async (e) => {
        e.preventDefault();
        
        // validate form inputs in db
        let fields = {
            user: {
                ...membershipInfoContext.user,
            },
            profile: {
                ...membershipInfoContext.profile
            },
        };

        try {
            const result = await RequestNextApi.post('/sales/sale-validate-join-form', 
              {
                jwtToken: getCookie('jwt-token'),
                fields
              }
            );
            if (result.data.success) {
                router.push('/community/membership/join/payment');
            } else {
                ShowNotification.error(result.data.message);
            }
            return result.data.success;
        } catch (error) {
            ShowNotification.warning('Fetch states failed.');
        }
    };

    return (
        <MarketingNavigation>
            <div className='relative w-full'>
                <div className='flex flex-col items-center justify-center w-full'>
                    <div className='absolute bg-blue-900 bg-opacity-75 inset-0' />
                    <div className='h-fit z-10 my-10'>
                        <div className='text-white text-center text-4xl font-bold'>
                            This is your community.
                        </div>
                        <div className='mx-auto max-w-7xl px-20 py-10 text-white text-2xl text-center'>
                            Kingdom Advisors membership connects you with a community of like-minded peers and gives you access to local, national, and virtual training opportunities.
                        </div>
                    </div>
                </div>
            </div>
            {!dateExpires && (
                <form 
                    onSubmit={handleClickSubmit}
                    className="relative mx-auto max-w-7xl py-8 px-6 lg:px-8"
                >
                    <RequiredInfo />
                    <MembershipType />
                </form>
            )}
        </MarketingNavigation>
    )
}

MembershipJoin.getLayout = page => <>{page}</>;
MembershipJoin.isPublic = true;
